/**
 * Canonical header chrome for the right-pane *detail* panes (file record, Google
 * Drive file, entity, GitHub, Slack, Granola, Calendar, …). Matches
 * `CalendarEventDetailPane`, the reference: a 44px-tall row (`h-11`), 8px inline
 * padding (`px-2`), a frosted translucent background (`bg-background/80` +
 * `backdrop-blur-lg`), and a bottom hairline (`border-b`). The action row spans
 * the full width (`w-full`) with tight `gap-1` icon spacing.
 *
 * Centralized so the metrics can't drift across panes — every detail pane opts
 * in via these two classes instead of hand-rolling the header. The shared
 * `PaneLayoutHeader` / `PaneLayoutHeaderActions` primitives (used app-wide, incl.
 * non-canvas surfaces) stay untouched — these classes only restyle the panes
 * that opt in.
 *
 * Chrome buttons in these headers (back, expand, close, object actions) use the
 * shared toolbar icon-button style: `variant="toolbarGhost" size="icon-sm"`
 * (a 28px rounded-sm square with a 14px icon).
 */
export const CANVAS_DETAIL_PANE_HEADER_CLASS =
  "!h-11 !px-2 bg-background/80 backdrop-blur-lg !border-b";

export const CANVAS_DETAIL_PANE_HEADER_ACTIONS_CLASS = "!gap-1 !w-full";
